import {Component} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {MatPaginatorIntl} from "@angular/material";

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent {

    constructor(private translate: TranslateService,
                private paginator: MatPaginatorIntl) {
        this.translate.setDefaultLang('es');
        this.paginator.itemsPerPageLabel = 'items';
    }
}



// WEBPACK FOOTER //
// ./src/app/app.component.ts